import { render } from "./SignUp.vue?vue&type=template&id=0cc68f22&scoped=true&name=signup"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=0cc68f22&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc68f22"]])

export default __exports__